import * as React from 'react';
import classNames from 'clsx';
import { ISpecialPromoSchema } from '../../repositories/newbuilding-card/entities/special_promos/SpecialPromoSchema';
import { MapContainer } from '../../containers/Map';
import { INewbuildingCardMapOptions } from '../../types/map';
import { NewbuildingMVKContainer } from '../newbuilding_mvk/container';
import * as style from './MVKOrMap.css';
import { SpecialPromoLinkContainer } from '../../containers/SpecialPromoLink';
import { NearbyNewbuildingsLinkContainer } from '../../containers/NearbyNewbuildingsLink';
import { LayoutBlock } from '../LayoutBlock';
import { Section } from '../Section';

export interface IMVKOrMapProps {
  hasNewbuildingMVK: boolean;
  specialPromo: ISpecialPromoSchema | null;
  hasCoords: boolean;
  mapOptions: INewbuildingCardMapOptions;
}

export const MVKOrMap: React.FC<IMVKOrMapProps> = props => {
  const {
    hasNewbuildingMVK,
    hasCoords,
    mapOptions: { visible },
  } = props;

  if (!visible || (!hasCoords && !hasNewbuildingMVK)) {
    return null;
  }

  return (
    <LayoutBlock>
      <Section data-nav-tab="infrastructure/Инфраструктура" id="infrastructure">
        <div className={style['content']}>
          <span className={classNames(style['header'], hasNewbuildingMVK && style['header-MVK'])}>
            <SpecialPromoLinkContainer />
            <NearbyNewbuildingsLinkContainer />
          </span>
          {hasNewbuildingMVK ? <NewbuildingMVKContainer /> : <MapContainer />}
        </div>
      </Section>
    </LayoutBlock>
  );
};
